package io.horion.cv.utils

import com.varabyte.kobweb.compose.ui.graphics.Color

object Colors {
    val Primary = Color.rgb(71, 71, 71)
    val LightDark = Color.rgb(163, 162, 162)
    val GoubeBlue = Color.rgb(33, 113, 181)
    val DarkBlue = Color.rgb(0, 55, 97)
    val NightBlue = Color.rgb(9, 32, 49)
    val mornblue = Color.rgb(51, 170, 255)
    val linear = Color.rgb(114, 243, 250)
    val Blue = Color.rgb(29, 64, 174)
    val DarkGray = Color.rgb(176, 176, 176)
    val LighterBlue = Color.rgb(6, 182, 212)
    val bluelight = Color.rgb(0, 213, 225)
    val LightGray = Color.rgb(230, 230, 230)
    val LightBlue = Color.rgb(15, 175, 255)
    val Warning = Color.rgb(255, 0, 0)
    val White = Color.rgb(255, 255, 255)
    val BlackLight = Color.rgb(44, 54, 87)
    val Red = Color.rgb(255, 0, 0)
    val Lightblue = Color.rgb(67, 94, 181)
    val field = Color.rgb(187, 187, 187)
    val lighterblue = Color.rgb(52, 152, 219)
    val button = Color.rgb(3, 27, 106)
    val HalfBlack= Color.rgba(r = 0, g = 0, b = 0, a = 0.5f)
    val HalfWhite = Color.rgba(r = 255, g = 255, b = 255, a = 0.5f)
    val secondary = Color.rgb(13, 184, 214)
    val LightGrayLine = Color.rgb(255, 252, 252)
    val GrayLight = Color.rgb(200, 200, 200)
    val BlueLight = Color.rgb(3, 104, 255)
    val Graytext= Color.rgb(135, 135, 135)
    val PriceGray = Color.rgb(242, 242, 242)
    val fillbox = Color.rgb(235, 235, 235)
    val borders = Color.rgb(136, 136, 136)
    val gray = Color.rgb(125, 125, 125)
    val lightblue = Color.rgb(3, 97, 173)
    val DarkBG = Color.rgb(59, 59, 69)
    val Black = Color.rgb(0, 0, 0)
    val Placeholder = Color.rgb(181, 181, 181)
    val holder = Color.rgb(70, 70, 79)
    val border = Color.rgb(252, 252, 252)
    val input = Color.rgb(188, 189, 194)
    val blue = Color.rgb(23, 61, 255)
    val orange = Color.rgb(254, 122, 1)
    val yellow = Color.rgb(255, 202, 5)
    val MoneyText = Color.rgb(153, 153, 153)
    val checkbox = Color.rgb(0, 153, 255)
    val black = Color.rgb(93, 93, 93)
    val lineBorder = Color.rgb(227, 227, 227)

    val WarningText          = Color.rgb(197, 32, 32)
    val WarningTextDark      = Color.rgb(248, 113, 113)
    val WarningSoftBg        = Color.rgb(254, 235, 235)
    val WarningSoftBgDark    = Color.rgba(r = 248, g = 113, b = 113, a = 0.15f)
    val WarningDot           = Color.rgb(220, 38, 38)
    val WarningDotDark       = Color.rgb(248, 113, 113)

    // ── Surfaces de popup / textes secondaires ───────────────────────────────
    val PopupBgDark          = Color.rgb(30, 30, 42)
    val SubtitleGray         = Color.rgb(120, 120, 130)
    val SubtitleGrayDark     = Color.rgb(150, 150, 165)
    val CloseGray            = Color.rgb(140, 140, 150)
    val CloseGrayDark        = Color.rgb(150, 150, 165)

    val CvText      = Color.rgb(51, 51, 51)
    val CvTextMuted = Color.rgb(85, 85, 85)
}